import React, {memo, useState} from 'react';
import useWebSocket, {ReadyState} from 'react-use-websocket';
import { useSelector } from "react-redux";
import { RootState } from "./reducers";
import { history } from "./configureStore";
import { useActions } from "./actions";
import * as Actions from "./actions/auth";
import { redirectLinks, WEBSOCKET_URL } from "./constants";

interface AppSocketProps {}
const AppSocket = (props:AppSocketProps) => {
    const authActions = useActions(Actions);
    const { user  } = useSelector((state: RootState) => state.auth);

    const {
        lastMessage,
        readyState,
    }:any = useWebSocket(WEBSOCKET_URL,{
        shouldReconnect: (closeEvent) => {
            return true;
        },
        onError: (event: WebSocketEventMap['error']) => {
            console.log("error event", event);
        },
        onOpen: (event: WebSocketEventMap['open']) => {
           // console.log("onOpen event", event);
        },
        onReconnectStop: (numAttempts: number) => {
            console.log("numAttempts", numAttempts);
        },
        queryParams: {userId: user && user.id},
        reconnectAttempts: 10,
        reconnectInterval: 3000,
        retryOnError: true
    });

    const logoutClient = async () => {
        await authActions.LogOut();
        history.replace("/accounts");
    }
    const redirectTo = (redirectKey:string) => {
       if(redirectLinks[redirectKey]){
           window.location.href = redirectLinks[redirectKey];
       }else{
           console.error("redirectKey not found", redirectKey);
       }
    }

    React.useEffect(() => {
        const msg:any = JSON.parse(lastMessage && lastMessage.data) || ""
        if(!!(msg && msg.type)) {
            switch (msg.type) {
                case "LOGOUT":
                    if(msg.data.userId === (user && user.id)) {
                        logoutClient().then(() => {
                        })
                    }
                    break;
                case "REDIRECT":
                    if(msg.data.userId === (user && user.id)) {
                        redirectTo(msg.data.to)
                    }
                    break;
                default:
                    console.log("no action needed");
            }
        }

    }, [lastMessage]);

    return (
            <></>
    );
};
export default memo(AppSocket);